/*global DSV, jQuery */

/** 
 * DSV Offices list
 */

(function ($, window) {
    "use strict";
    let selfScope;

    DSV.ui.offices = {
        
        DOM: {
            module: document.querySelector('.offices-list'),
            resultList: document.querySelector('.offices-list__result'),
        },
        
        setButtonText(btnText) {
            selfScope.options.toggleBtn.textContent = btnText;
        },
        
        
        toggleShowOffices(e) {
            e.preventDefault();
            e.stopPropagation();
            selfScope.options.toggleBtn.blur();

            const container = selfScope.DOM.resultList;
            const list = selfScope.DOM.resultList;

            if(container.classList.contains(selfScope.options.hideClass)){
                container.classList.remove(selfScope.options.hideClass);
                selfScope.setButtonText(selfScope.options.hideText);
            } else {
                container.classList.add(selfScope.options.hideClass);
                selfScope.setButtonText(selfScope.options.showText);
                TweenLite.to(window, 0.1, {scrollTo: {y: list, offsetY:150}});
            }
        },

        init(){
            selfScope = this;
            selfScope.options = {
                hideClass:"hide-offices",
                showText: this.DOM.resultList.getAttribute("data-showtext"),
                hideText: this.DOM.resultList.getAttribute("data-hidetext"),
                toggleBtn: this.DOM.module.querySelector(".offices-list__toggle")
            };

            // enable data-links in offices result list 
            DSV.ui.enableDataLinks();
            
            if(this.DOM.resultList.classList.contains(selfScope.options.hideClass)){                
                selfScope.setButtonText(selfScope.options.showText);
            } else {
                selfScope.setButtonText(selfScope.options.hideText);
            }

            selfScope.options.toggleBtn.addEventListener("click", selfScope.toggleShowOffices);
        }
    };
})(jQuery, window);